import { useQuery } from "react-query";
import axios from "axios";
import moment from "moment";

import { getApiSitePrefix } from "../../functions/SiteDefaults";

const apiSitePrefix = getApiSitePrefix();

const augmentData = (data) => {
  const augmentedData = data.map((record) => {
    return {
      ...record, 
      tripDateDDMMM: record.tripDate ? moment(record.tripDate).format("DD MMM") : record.requestedDate ? moment(record.requestedDate).format("DD MMM") : "",
      expectedWeightKgRounded: record.expectedWeightKg?.round(2).toLocaleString(),
      expectedChargeableWeightRounded: record.expectedChargeableWeight?.round(2).toLocaleString(),
      expectedVolumeRounded: record.expectedVolume?.round(2).toLocaleString(),
      rateRounded: record.rate?.round(4).toLocaleString(),
      targetRateRounded: record.targetRate?.round(4).toLocaleString(),
      eurAmountRounded: record.eurAmount?.round(2).toLocaleString(),
      usdAmountRounded: record.usdAmount?.round(2).toLocaleString(),
      gbpAmountRounded: record.gbpAmount?.round(2).toLocaleString(),
      mainDeck: record.deckRequired === "MAIN",
    }
  });
  return augmentedData;
}

const getData = async (tableRef, queryClient, key, extraKeys, useCache, callback) => {
  if (tableRef && tableRef.current && tableRef.current.state && tableRef.current.state.lastEditingRow){
    return queryClient.getQueryData(key);
  }
  if (useCache) {
    const cachedData = queryClient.getQueryData([...key, '_cached']);
    if (cachedData) {
      if (callback) {callback(cachedData, extraKeys)}
      return cachedData
    };
    const realData = queryClient.getQueryData(key);
    if (realData) {
      if (callback) {callback(realData, extraKeys)}
      return realData;
    }
  }
  let extendedPath = "";
  if (extraKeys) {
    extendedPath = extraKeys.join("/");
  }
  let data = [];
  if(extraKeys.length > 0) {
    const result = await axios.get(
      `${apiSitePrefix}/bookings/get/${extendedPath}`
    );
    data = result?.data;
  }
  if (callback) {callback(data, extraKeys)}
  return augmentData(data);
};

const buildKey = (props) => {
  let key = ['Booking'];
  if (props.extraKeys) {
    key = [
      ...key,
      ...props.extraKeys
    ]
  }
  const queryKey = [...key];
  if (props.useCache) {
    queryKey.push('_cached');
  }

  return {key, queryKey};
}

export default function useBookings(props) {    
  const options = {
    ...props.options
  }

  const {key, queryKey} = buildKey(props);

  return useQuery(
    queryKey, 
    () => getData(props.tableRef, props.queryClient, key, props.extraKeys, props.useCache, props.callback), 
    options
  );
}
export {buildKey}